<template>
  <section
    class="page-section d-flex flex-column align-items-stretch"
    :style="{ background: sectionBg, color: textColor }"
  >

    <template v-for="(data, idx) in data.content" v-if="data[lenBoolKey]">
      <carousel :key="idx" :bg="bg" :demo-bot="data.demoBot" :data="data" v-if="data.slides.length > 1"/>

      <content-wrap :key="idx" :bg="bg" :demo-bot="data.demoBot" :data="data" v-else/>
    </template>

  </section>
</template>

<script>
  import { reportLengths } from '@/lib/consts'
  import { gradPtColor, darken } from '@/lib/funcs'
  import Carousel from '@/components/report/Carousel'
  import ContentWrap from '@/components/report/ContentWrap'
  import StateMixin from '@/components/report/mixins/StateMixin'

  export default {
    name: 'PageSection',
    mixins: [ StateMixin ],
    props: {
      data: {
        type: Object,
        required: true
      },
      idx: {
        type: Number,
        required: true
      }
    },
    data () {
      return {
        sideNavStartWp: null,
        sideNavStopWp: null,
        deskCtrlsStartWp: null,
        deskCtrlsStopWp: null,
        wpOffsetMod: 0
      }
    },
    computed: {
      bg () {
        return this.data.bg.match( /(?:accent|mainColor)/ )
          ? this[ this.data.bg ]
          : this.data.bg === ''
            ? '#ffffff'
            : this.data.bg
      },

      hasBg () { return this.data.bg !== '' },

      sectionBg () {
        switch ( this.data.bg.toLowerCase() ) {
          case 'accent':
            return 'linear-gradient(135deg,' + this.accent + ' 0%,' + gradPtColor( ...this.colorsRev, 0.6 ) + ' 100%)'

          case 'maincolor':
            return 'linear-gradient(135deg,' + this.mainColor + ' 0%,' + darken( this.mainColor, 0.77 ) + ' 100%)'

          case '':
            return '#fafafa'

          default:
            return this.data.bg
        }
      },

      textColor () { return this.bg.match( /^#(?:fafafa|f{3,6})$/i ) ? '#1F1F1F' : '#ffffff' },

      lenBoolKey () { return this.reportLen === reportLengths.long ? 'inLong' : 'inShort' }
    },
    components: { Carousel, ContentWrap },
    methods: {
      createSideNavWaypoints () {
        this.sideNavStartWp = new window.Waypoint( {
          element: this.$el,
          handler: ( dir ) => {
            this.$store.dispatch( 'setSideNavOnWhite', dir === 'down' )
          },
          offset: () => {
            return ((window.innerHeight - this.sideNavHeight) / 2) + this.wpOffsetMod
          }
        } )
        this.sideNavStopWp = new window.Waypoint( {
          element: this.$el,
          handler: ( dir ) => {
            this.$store.dispatch( 'setSideNavOnWhite', dir === 'up' )
          },
          offset: () => {
            return ((this.$el.offsetHeight - ((window.innerHeight - this.sideNavHeight) / 2)) * -1) - 150
          }
        } )
      },
      createDeskCtrlsWaypoints () {
        this.deskCtrlsStartWp = new window.Waypoint( {
          element: this.$el,
          handler: ( dir ) => {
            this.$store.dispatch( 'setDeskCtrlsOnWhite', dir === 'down' )
          },
          offset: () => {
            return this.wpOffsetMod + this.deskCtrlsHeight
          }
        } )
        this.deskCtrlsStopWp = new window.Waypoint( {
          element: this.$el,
          handler: ( dir ) => {
            this.$store.dispatch( 'setDeskCtrlsOnWhite', dir === 'up' )
          },
          offset: () => {
            return (this.$el.offsetHeight * -1) + this.deskCtrlsHeight
          }
        } )
      }
    },
    mounted () {
      if ( !this.isMobile && !this.hasBg ) {
        setTimeout( () => {
          if ( this.idx === 0 ) {
            let rect = this.$el.getBoundingClientRect()
            this.wpOffsetMod = rect.top - window.innerHeight
          }
          this.wpOffsetMod = this.wpOffsetMod + parseInt( window.getComputedStyle( this.$el ).marginTop ) // account for any top margin
          this.createSideNavWaypoints()
          this.createDeskCtrlsWaypoints()
        }, 500 )
      }
    },
    beforeDestroy () {
      if ( !this.hasBg ) {
        if ( this.sideNavStartWp !== null ) {
          this.sideNavStartWp.destroy()
        }
        if ( this.sideNavStopWp !== null ) {
          this.sideNavStopWp.destroy()
        }
        if ( this.deskCtrlsStartWp !== null ) {
          this.deskCtrlsStartWp.destroy()
        }
        if ( this.deskCtrlsStopWp !== null ) {
          this.deskCtrlsStopWp.destroy()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/report/PageSection.vue